import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EmojiChar, EmojiGroup, emojiGroups$ } from '../../htmlEditor/EmojiData';
import { BaseControlValueAccessor } from '../../util/BaseControlValueAccessor';

import styles from './EmojiPicker.module.less';

@Component({
	selector: 'emoji-picker',
	templateUrl: './EmojiPicker.Component.html',
	host: {
		'[class]': 'styles.root'
	},
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => EmojiPickerComponent),
		multi: true
	}],
	standalone: false
})
export class EmojiPickerComponent extends BaseControlValueAccessor<EmojiChar[]> implements OnInit {
	@Input() public maxLength: number = 0;

	public readonly styles = styles;

	public emojiGroups: EmojiGroup[];
	public selectedGroup: EmojiGroup;

	public filter: string;
	public filteredEmojis: EmojiChar[];

	public ngOnInit(): void {
		emojiGroups$.then(groups => {
			this.emojiGroups = groups;
			this.selectedGroup = groups[0];
		});
	}

	public addEmoji(emoji: EmojiChar): void {
		if(this.value.length < this.maxLength &&
			this.value.every(e => e.char !== emoji.char)) {
			this.updateModelValue([...this.value, emoji]);
		}
	}

	public removeEmoji(index: number): void {
		this.updateModelValue(this.value.filter((_, i) => i !== index));
	}
}
